import EndPoint from 'Api/EndPoint';
import Client from 'Api/Client';

const endpoint = `${EndPoint.Host}/${EndPoint.Config}`;

export async function materialCategorySearch(data) {
  return await Client.get(`${endpoint}/material/category/search`, data, true);
}

export async function materialCategorySearchDetail(id) {
  return await Client.get(`${endpoint}/material/category/search/${id}`, {}, true);
}

export async function b2cMaterialList(data) {
  return await Client.get(`${endpoint}/material`, data, true);
}

export async function b2cMaterialCategory(data) {
  return await Client.get(`${endpoint}/material/category`, data, true);
}

export async function b2cMaterialAutoComplete(data) {
  return await Client.get(`${endpoint}/material/autoComplete`, data, true);
}

// 추천 자재(옵션) 리스트 + 카테고리
export async function getMaterialAutoCart(data) {
  return await Client.get(`${endpoint}/material/autoCart/options`, data, true);
}

// 현장투입예정자재
export async function getMaterialCommon(data) {
  return await Client.get(`${endpoint}/material/scheduledOnField`, data, true);
}

// 현장투입예정자재 카테고리
export async function materialCategoryCommonBudget(data) {
  return await Client.get(`${endpoint}/material/category/commonBudget`, data, true);
}
